// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_8giT0","visuallyhidden":"_2Y1JC","hide-text":"_1E_eX","center":"_26I9o","noprint":"_1uKJc","root":"_2uthF","item":"_1PkL9","highlight":"mof_R","active":"_3TZ5O"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-grade/styles/Grade.scss
 ** module id = 942
 ** module chunks = 1
 **/